"use client"

import React, { useEffect, useState } from "react" // useEffect importieren
import Link from "next/link"
import { useTranslations } from "next-intl"

import { cn } from "@/components/ui/helpers/utils"
import HtmlTextBox from "@/components/storyblok/common/HtmlTextBox"

interface CategoryDescriptionProps {
  text: string
  contentAnchor: string
}

export default function CategoryDescriptionClient(props: CategoryDescriptionProps) {
  // Der Anfangszustand ist `false` (unkollabiert)
  const [collapsed, setCollapsed] = useState(false)
  // 1. Wir fügen den "isMounted"-Zustand hinzu.
  const [isMounted, setIsMounted] = useState(false)
  const t = useTranslations("storefront")

  // 2. Dieser Effekt wird NUR im Client ausgeführt, um isMounted auf true zu setzen.
  useEffect(() => {
    setIsMounted(true)
  }, [])

  // 3. Solange die Komponente nicht im Client gemountet ist, rendern wir eine
  //    sichere, nicht-responsive Version, die dem "unkollabierten" Zustand entspricht.
  if (!isMounted) {
    return (
      <>
        {/* Die Textbox wird ohne Höhenbeschränkung gerendert */}
        <HtmlTextBox classname="[&>p]:my-0" text={props.text} />
        <div className="flex w-full flex-row justify-between">
          {/* Leeres Element, damit der "Weniger"-Button rechts bleibt */}
          <span />
          {/* Wir zeigen nur den "Weniger"-Button an */}
          <button className="block p-0 text-sm underline">{t("category.less")}</button>
        </div>
      </>
    )
  }

  // 4. Nachdem die Komponente sicher gemountet ist, wird die volle,
  //    responsive Logik gerendert.
  return (
    <>
      <HtmlTextBox
        classname={cn({
          "h-[3.25rem] overflow-hidden sm:h-auto [&>p]:my-0 [&>*]:text-ellipsis [&>*]:line-clamp-2 sm:[&>*]:line-clamp-none":
            collapsed,
        })}
        text={props.text}
      />
      <button
        className={cn("block p-0 text-sm underline sm:hidden", {
          hidden: !collapsed,
        })}
        onClick={() => setCollapsed(!collapsed)}
      >
        {t("category.more")}
      </button>
      <div className="flex w-full flex-row justify-between">
        <Link
          prefetch={false}
          className={cn("block text-sm underline", {
            "hidden sm:block": collapsed,
          })}
          href={`#${props.contentAnchor}`}
          target={"_self"}
        >
          {t("category.more")}
        </Link>
        <button
          className={cn("block p-0 text-sm underline sm:hidden", {
            hidden: collapsed,
          })}
          onClick={() => setCollapsed(!collapsed)}
        >
          {t("category.less")}
        </button>
      </div>
    </>
  )
}
